// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__3906Q","on":"style_on__1TvQc","rate":"style_rate__11Sgl","odds":"style_odds___fjqI"};